<script>
import MetisMenu from 'metismenujs/dist/metismenujs';
import { mapGetters } from 'vuex';

// import { menuItems } from './menu';

/**
 * Sidenav component
 */
export default {
  data() {
    return {
      // menuItems: menuItems,
      menuData: null,
    };
  },
  computed: {
    ...mapGetters({
      UserInfo: 'user/UserInfo',
      AppInfo: 'core/AppInfo',
    }),
    menuItems() {
      return [
        {
          id: 1,
          label: this.$t('sidebar.menu'),
          isTitle: true,
        },
        {
          id: 2,
          label: this.$t('sidebar.dashboard'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13m7 7v-5h4v5zm2-15.586l6 6V15l.001 5H16v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H6v-9.586z"/></svg>',
          link: '/',
        },
        {
          id: 3,
          label: this.$t('sidebar.member'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5S4.5 6.505 4.5 8.5S6.005 12 8 12"/></svg>',
          link: '/thanh-vien',
        },
        {
          id: 4,
          label: this.$t('sidebar.agency'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5S4.5 6.505 4.5 8.5S6.005 12 8 12"/></svg>',
          link: '/dai-ly',
          agency: true,
        },
        {
          id: 5,
          label: this.$t('sidebar.investment'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M11.5 1L2 6v2h19V6m-5 4v7h3v-7M2 22h19v-3H2m8-9v7h3v-7m-9 0v7h3v-7z"/></svg>',
          link: '/dau-tu',
        },
        {
          id: 10,
          label: this.$t('sidebar.investmentDemo'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M11.5 1L2 6v2h19V6m-5 4v7h3v-7M2 22h19v-3H2m8-9v7h3v-7m-9 0v7h3v-7z"/></svg>',
          link: '/dau-tu-thu',
          demo: true,
        },
        {
          id: 8,
          label: this.$t('sidebar.manager'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 15 15"><path fill="none" stroke="white" d="M13.5 6V2.5a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9m.93-3.5H9.5a2 2 0 1 0 0 4h4.93a.07.07 0 0 0 .07-.07V5.57a.07.07 0 0 0-.07-.07Z"/></svg>',
          link: '/quan-ly-dau-tu',
        },
        {
          id: 6,
          label: this.$t('sidebar.history'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M12 21q-3.45 0-6.012-2.287T3.05 13H5.1q.35 2.6 2.313 4.3T12 19q2.925 0 4.963-2.037T19 12q0-2.925-2.037-4.962T12 5q-1.725 0-3.225.8T6.25 8H9v2H3V4h2v2.35q1.275-1.6 3.113-2.475T12 3q1.875 0 3.513.713t2.85 1.924q1.212 1.213 1.925 2.85T21 12q0 1.875-.712 3.513t-1.925 2.85q-1.213 1.212-2.85 1.925T12 21m2.8-4.8L11 12.4V7h2v4.6l3.2 3.2z"/></svg>',
          link: '/lich-su',
        },
        {
          id: 7,
          label: this.$t('sidebar.support'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M11 18h2v-2h-2zm1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-14a4 4 0 0 0-4 4h2a2 2 0 0 1 2-2a2 2 0 0 1 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 0 0-4-4"/></svg>',
          link: '/ho-tro',
        },
        {
          id: 11,
          label: this.$t('sidebar.android'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"/></svg>',
          link: this.AppInfo.url ? this.AppInfo.url : '',
          download: true,
        },
        {
          id: 12,
          label: this.$t('sidebar.ios'),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"/></svg>',
          link: this.AppInfo.ios ? this.AppInfo.ios : '',
          download: true,
        },
      ];
    },
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu');
    var links = document.getElementsByClassName('side-nav-link-ref');
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active');
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('mm-active');
        const parent2 = parent.parentElement.closest('ul');
        if (parent2 && parent2.id !== 'side-menu') {
          parent2.classList.add('mm-show');

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('mm-active');
            var childAnchor = parent3.querySelector('.has-arrow');
            var childDropdown = parent3.querySelector('.has-dropdown');
            if (childAnchor) childAnchor.classList.add('mm-active');
            if (childDropdown) childDropdown.classList.add('mm-active');

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== 'side-menu') {
              parent4.classList.add('mm-show');
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== 'side-menu') {
                parent5.classList.add('mm-active');
                const childanchor = parent5.querySelector('.is-parent');
                if (childanchor && parent5.id !== 'side-menu') {
                  childanchor.classList.add('mm-active');
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    onlyAgency(item) {
      return item.agency !== undefined ? this.UserInfo.agency !== 0 : false;
    },
    isDemo(item) {
      return item.demo !== undefined ? item.demo : false;
    },
    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle('mm-show');
    },
    onComingSoon() {
      this.$toastr.w('Coming Soon', 'Notification!!!');
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="item in menuItems">
        <li class="menu-title" v-if="item.isTitle" :key="item.id">
          {{ $t(item.label) }}
        </li>
        <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
          <a v-if="hasItems(item)" href="javascript:void(0);" class="is-parent"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }">
            <!-- <i :class="`bx ${item.icon}`" v-if="item.icon"></i> -->
            <span v-if="item.icon" v-html="item.icon"></span>
            <span style="margin-left: 5px;">{{ $t(item.label) }}</span>
            <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{
              $t(item.badge.text) }}</span>
          </a>
          <router-link :to="item.link" v-if="onlyAgency(item) && item.agency" class="side-nav-link-ref">
            <!-- <i :class="`bx ${item.icon}`" v-if="item.icon"></i> -->
            <span v-if="item.icon" v-html="item.icon"></span>
            <span  style="margin-left: 5px;">{{ $t(item.label) }}</span>
            <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">
              {{ $t(item.badge.text) }}
            </span>
          </router-link>
          <router-link :to="item.link" v-if="!hasItems(item) && !item.agency && !item.download" class="side-nav-link-ref"
            :class="{ demo: isDemo(item) }">
            <!-- <i :class="`bx ${item.icon}`" v-if="item.icon"></i> -->
            <span v-if="item.icon" v-html="item.icon"></span>
            <span  style="margin-left: 5px;">{{ $t(item.label) }}</span>
            <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">
              {{ $t(item.badge.text) }}
            </span>
          </router-link>
          <!-- Download -->
          <!-- Android -->
          <a :href="item.link" v-if="!hasItems(item) && item.download && item.link" class="side-nav-link-ref"
            :class="{ demo: isDemo(item) }" target="_blank">
            <!-- <i :class="`bx ${item.icon}`" v-if="item.icon"></i> -->
            <span v-if="item.icon" v-html="item.icon"></span>
            <span  style="margin-left: 5px;">{{ $t(item.label) }}</span>
            <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">
              {{ $t(item.badge.text) }}
            </span>
          </a>
          <!-- IOS -->
          <a v-if="!hasItems(item) && item.download && !item.link" class="side-nav-link-ref"
            :class="{ demo: isDemo(item) }" target="_blank" @click="onComingSoon">
            <!-- <i :class="`bx ${item.icon}`" v-if="item.icon"></i> -->
            <span v-if="item.icon" v-html="item.icon"></span>
            <span  style="margin-left: 5px;">{{ $t(item.label) }}</span>
            <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">
              {{ $t(item.badge.text) }}
            </span>
          </a>
          <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li v-for="(subitem, index) of item.subItems" :key="index">
              <router-link :to="subitem.link" v-if="!hasItems(subitem)" class="side-nav-link-ref">{{ $t(subitem.label)
              }}</router-link>
              <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">{{
                $t(subitem.label) }}</a>
              <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                  <router-link :to="subSubitem.link" class="side-nav-link-ref">{{ $t(subSubitem.label) }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
      <li v-if="false">
        <a :href="AppInfo.url" target="_blank">
          <i class="bx bx-devices text-danger"></i>
          <span class="text-danger">Android App</span>
        </a>
      </li>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
